import {
  documentModelNS,
  iDocDataUpdateBasePayload,
} from '../../document.baseType';
import { iDocBaseData } from '../docBase.type';

/** Reducers Action */
export const updateDocBaseDataAction = (
  payload: iDocDataUpdateBasePayload<iDocBaseData>,
) => ({
  type: 'updateDocBaseDataReducer',
  payload,
});

/** Effects Action */
/** 纪要转写 */
// 初始化 DocBase
export const initDocBaseAction = (payload: iDocDataUpdateBasePayload<null>) => {
  const actionType = `${documentModelNS}/initTransDocBaseEffect`;

  return {
    type: actionType,
    payload,
  };
};
